import React from 'react';
import downChevron from 'assets/chevron-down.svg';
import useHoldRepeat from 'hooks/useRepeatHook';

const ChevronDownIcon = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}): JSX.Element => {
  const { start, stop } = useHoldRepeat(onClick);

  return (
    <img
      style={{ cursor: 'pointer', userSelect: 'none' }}
      draggable={false}
      src={downChevron}
      alt="down-chevron-icon"
      className={className}
      onMouseDown={() => {
        start();
      }}
      onMouseUp={() => {
        stop();
      }}
    />
  );
};

export default ChevronDownIcon;
